import { QrCode, MessageSquare, Smartphone } from "lucide-react";
import { Card, CardContent } from "@jambushrushti/components/ui/card";

interface FeedbackQRCodeProps {
  compact?: boolean;
  className?: string;
}

export function FeedbackQRCode({
  compact = false,
  className = "",
}: FeedbackQRCodeProps) {
  // Generate QR code URL - this links to the feedback form
  const feedbackUrl = `${window.location.origin}/feedback`;
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(feedbackUrl)}&bgcolor=FAF7F2&color=2D2A26`;

  if (compact) {
    return (
      <div
        className={`flex items-center gap-4 rounded-xl border border-primary/20 bg-primary/5 p-4 ${className}`}
      >
        <img
          src={qrCodeUrl}
          alt="Scan to give feedback"
          className="h-16 w-16 rounded-lg"
        />
        <div>
          <p className="font-heading text-sm font-semibold text-foreground">
            Share Your Feedback
          </p>
          <p className="text-xs text-muted-foreground">
            Scan QR code with your phone
          </p>
        </div>
      </div>
    );
  }

  return (
    <Card
      className={`overflow-hidden border-primary/20 bg-gradient-to-br from-primary/5 to-background ${className}`}
    >
      <CardContent className="p-6 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
          <MessageSquare className="h-6 w-6 text-primary" />
        </div>

        <h3 className="font-heading mb-2 text-lg font-bold text-foreground">
          Visitor Feedback
        </h3>
        <p className="mb-4 text-sm text-muted-foreground">
          Scan this QR code to share your experience and help us improve
        </p>

        <div className="relative inline-block">
          <div className="absolute -inset-2 rounded-2xl bg-gradient-to-br from-primary/20 to-gold/20 blur-sm" />
          <img
            src={qrCodeUrl}
            alt="Scan to give feedback"
            className="relative mx-auto h-40 w-40 rounded-xl border-4 border-background shadow-lg"
          />
        </div>

        <div className="mt-4 flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <Smartphone className="h-4 w-4" />
          <span>Scan with your mobile camera</span>
        </div>
      </CardContent>
    </Card>
  );
}
